import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import { ReactTagManager } from 'react-gtm-ts';
import { useLocation } from 'react-router-dom';
import { Button } from '../Button';

type ErrorContainerProps = {
	errorMessage?: string;
	status?: number;
	action?: () => void;
	actionName?: string;
	error?: unknown;
	meta?: Array<string>;
};

export const ErrorContainer = ({ errorMessage, status, action, actionName, error, meta }: ErrorContainerProps) => {
	const { t } = useTranslation();

	const { pathname } = useLocation();

	const message = useMemo(() => {
		switch (status) {
			case 403:
				return t('misc.forbiddenError');
			default:
				return errorMessage || t('misc.genericError');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [status, errorMessage]);

	useEffect(() => {
		if (error instanceof AxiosError) {
			ReactTagManager.action({
				event: 'endpoint_request_error',
				page_error_url: pathname,
				endpoint_error_url: error?.config?.url,
				endpoint_error_status: error?.code,
				meta,
			});
		} else {
			ReactTagManager.action({
				event: 'endpoint_request_error',
				page_error_url: pathname,
				error,
				meta,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="flex flex-column justify-content-center align-items-center text-center">
			<p>{message}</p>
			{action && <Button label={actionName || t('actions.tryAgain')} onClick={() => action()} />}
		</div>
	);
};
